/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { MatriculadoService } from './_services/matriculado.service';
import { ComprobanteService } from './_services/comprobante.service';
import { DescargaService } from './_services/descargas.service';
import { ArancelesService } from './_services/aranceles.service';
import { CertificadoService } from './_services/certificados.service'
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
// used to create fake backend
import { fakeBackendProvider } from './_helpers/index';

import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { AuthGuard } from './_guards/index';
import { JwtInterceptor } from './_helpers/index';
import { AuthenticationService, UserService } from './_services/index';
import { LoginComponent } from './login/index';
import { HomeComponent } from './home/index';
import { AuthStatusGuard } from './_guards/authStatus.guard';
import { DatosComponent } from './datos/datos.component';
import { BibliotecaComponent } from './biblioteca/biblioteca.component';
import { FormulariosComponent } from './formularios/formularios.component';
import { ResolucionesComponent } from './resoluciones/resoluciones.component';
import { ArancelesComponent } from './aranceles/aranceles.component';
import { BalanceComponent } from './balance/balance.component';
import { NotaRowComponent } from './home/nota.component';
import { DefaultRowComponent } from './home/default.component';
import { DeudaRowComponent } from './home/deuda.component';
import { CertificadoComponent } from './certificado/certificado.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PendienteDialog } from './certificado/certificado.dialog.component';
import { DetalleDialog } from './certificado/certificado.dialog-detalle.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CertificadoDistribuidoraComponent } from './distribuidora/certificado/certificado.component';
import { HomeDistribuidoraComponent } from './distribuidora/home/home.component';
import { MatriculadoGuard } from './_guards/matriculado.guard';
import { DistribuidoraGuard } from './_guards/distribuidora.guard';
import { PasswordComponent } from './password/password.component';
import { ComunicacionComponent } from './comunicacion/comunicacion.component';
import { ComunicacionGuard } from './_guards/comunicacion.guard';
import { EmailComponent } from './password/email.component';
import { TribunalComponent } from './tribunal/tribunal.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { VideoplayerComponent } from './videoplayer/videoplayer.component';
import { DocumentosComponent } from './documentos/documentos.component';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        routing,
        NoopAnimationsModule,
        MatDialogModule,
        MatButtonModule,
        MatCheckboxModule,
        ReactiveFormsModule
    ],
    declarations: [
        AppComponent,
        LoginComponent,
        HomeComponent,
        DatosComponent,
        BibliotecaComponent,
        FormulariosComponent,
        ResolucionesComponent,
        ArancelesComponent,
        BalanceComponent,
        NotaRowComponent,
        DefaultRowComponent,
        DeudaRowComponent,
        CertificadoComponent,
        PendienteDialog,
        DetalleDialog,
        CertificadoDistribuidoraComponent,
        HomeDistribuidoraComponent,
        PasswordComponent,
        EmailComponent,
        ComunicacionComponent,
        TribunalComponent,
        VideoPlayerComponent,
        VideoplayerComponent,
        DocumentosComponent
    ],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        AuthGuard,
        AuthStatusGuard,
        MatriculadoGuard,
        DistribuidoraGuard,
        ComunicacionGuard,
        AuthenticationService,
        ArancelesService,
        DescargaService,
        ComprobanteService,
        UserService,
        MatriculadoService,
        CertificadoService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        // providers used to create fake backend
        // fakeBackendProvider
    ],
    entryComponents: [PendienteDialog, DetalleDialog],
    bootstrap: [AppComponent]
})

export class AppModule { }
